import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { SeasonsService } from './seasons.service';

@Injectable()
export class SeasonsAccessGrantedResolver implements Resolve<any> {

    constructor(
        private _seasonsSrv: SeasonsService
    ) {
    }

    async resolve(): Promise<boolean> {
        const { access } = await this._seasonsSrv.checkAccessGranted();

        return access;
    }
}
